import {inlineError, streamify, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
@streamify('execute')
class UpdateChannelUserAlertUseCase extends UseCase {
  constructor({repository, getCurrentUserService}) {
    super()
    this._repository = repository
    this._getCurrentUserService = getCurrentUserService
  }

  /**
   * @return {Promise<Object, Error>}
   */
  @tracer({metric: 'UpdateChannelUserAlertUseCase#execute'})
  @inlineError
  async execute({userAlert, activeEmail, activePush}) {
    const userEntity = await this._getCurrentUserService.execute()
    const userId = userEntity.getId()
    const {alertId} = userAlert

    const [error, response] = await this._repository.updateChannelUserAlert({
      userId,
      alertId,
      activeEmail,
      activePush
    })

    if (error) return Promise.reject(error)

    return response
  }
}

export default UpdateChannelUserAlertUseCase
